// extracted by mini-css-extract-plugin
export default {"icon":"Autosave_icon__E7xZR","text":"Autosave_text__JL0QH","pill":"Autosave_pill__jNvsi","autosaving":"Autosave_autosaving__MJlfy","failed":"Autosave_failed__ucGPw"};